import { useAutocompleteSource } from '@eas/common-web';
import { DictProposerDistinctionAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useProposerDistinctions() {
  return useAutocompleteSource<DictProposerDistinctionAutocomplete>({
    url: `${EvidenceApiUrl.DICT_PROPOSER_DISTINCTION}/autocomplete`,
  });
}
